const stringToHSL = (input: string) => {
    let hash = 2166136261 //FNV hash offset basis

    for (let i = 0; i < input.length; i++) {
        hash ^= input.charCodeAt(i)
        hash *= 16777619 //FNV hash prime
    }

    return `hsl(${hash % 360} 80% 51%)`
}

/**
 * Generates a unique color based on the `firstName`, `lastName` and `email` of a user.
 * @param firstName
 * @param lastName
 * @param email
 * @returns the *hsl* formatted color string.
 */
export const generateAvatarColor = (
    firstName: string | undefined,
    lastName: string | undefined,
    email: string | undefined
) => stringToHSL(`${firstName}${lastName}${email}`)
